/**
 * Created by Ram on 12/05/2017.
 */

import React, { Component } from "react";
import MapAnalytics from "../presentation/MapAnalytics";
import deviceEnum from "../../enum/DeviceEnum";
import osEnum from "../../enum/OsEnum";

class MapAnalyticsWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      testInstanceId: this.props.pageParameters[0],
      testInstance: "",
      devices: [],
      showRoute: false,
      showFences: false,
      trackedLocations: [],
      allPolygons: [],
      deviceSelected: deviceEnum.ALL,
      osSelected: osEnum.BOTH,
      allCheckins: [],
      isLoading: true
    };
  }

  componentDidMount() {
    this.getSingleTestInstance();
  }

  getSingleTestInstance = () => {
    fetch(
      "/service/getSingleTestInstanceDetails?testInstanceId=" +
        this.state.testInstanceId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }
    ).then(response => {
      if (response.status === 200) {
        response.json().then(testInstance => {
          const fences = [];
          testInstance.devices.forEach(device => {
            if (device.log && device.log.fences) {
              device.log.fences.forEach(fence => {
                if (fence.geometry) {
                  fences.push(fence.geometry);
                }
              });
            }
          });

          this.getTestInstanceDevices(testInstance);
          this.setState({ testInstance, fences });
        });
      }
    });
  };

  //get the list of devices for the test instance
  getTestInstanceDevices = testInstance => {
    let devices = [];
    testInstance.devices.map(testDevice => {
      devices.push(testDevice.deviceId);
    });

    this.setState({ isLoading: true }, () => {
      fetch("/service/getClusterDevices?devices=" + devices, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        credentials: "same-origin"
      }).then(response => {
        if (response.status === 200) {
          response.json().then(devices => {
            this.setState(
              { devices, isLoading: false },
              this.showDeviceCheckins
            );
          });
        }
      });
    });
  };

  updateRuleDownload = () => {
    this.setState(
      prevState => ({ showFences: !prevState.showFences }),
      this.showRulesDownload
    );
  };

  updateShowRoute = () => {
    this.setState(
      prevState => ({ showRoute: !prevState.showRoute }),
      this.showRoute
    );
  };

  updateDevice = e => {
    const value = e.target.value;
    this.setState({ deviceSelected: value }, this.showDeviceCheckins);
  };

  updateOs = e => {
    const value = e.target.value;
    this.setState({ osSelected: value }, this.showDeviceCheckins);
  };

  showDeviceCheckins = () => {
    let checkins = [];
    let selectedDevice = this.state.deviceSelected;
    if (this.state.testInstance.devices) {
      let devicesState = [];

      if (selectedDevice === deviceEnum.ALL) {
        const deviceIds = this.state.devices
          .filter(
            ({ os }) =>
              this.state.osSelected === os ||
              this.state.osSelected === osEnum.BOTH
          )
          .map(({ _id }) => _id);
        const devicesFiltered = this.state.testInstance.devices.filter(
          ({ deviceId }) => deviceIds.includes(deviceId)
        );
        devicesState = Object.values(devicesFiltered);
      } else {
        let displayDeviceStatus = this.state.testInstance.devices.find(
          testDevice => testDevice.deviceId === selectedDevice
        );
        devicesState.push(displayDeviceStatus);
      }

      devicesState.map(deviceState => {
        if (
          deviceState.hasOwnProperty("log") &&
          deviceState.log.hasOwnProperty("triggers")
        ) {
          deviceState.log.triggers.map(trigger => {
            const deviceInfo = this.state.devices.find(
              ({ _id }) => _id === deviceState.deviceId
            );
            if (trigger.hasOwnProperty("checkinLocationUpdate")) {
              let checkin = {
                lat: Number(trigger.checkinLocationUpdate.lat),
                lng: Number(trigger.checkinLocationUpdate.lng),
                time: trigger.time,
                deviceId: deviceState.deviceId,
                deviceName: deviceInfo.name,
                zoneId: trigger.zoneId
              };
              checkins.push(checkin);
            }
          });
        }
      });
    }

    this.setState({ allCheckins: checkins });
  };

  showRulesDownload = () => {
    if (this.state.showFences) {
      if (this.state.testInstance.devices) {
        let allPolygons = [];
        let devicesState = Object.values(this.state.testInstance.devices);
        devicesState.map(deviceState => {
          if (deviceState["log"]) {
            if (deviceState["log"].fences) {
              let fences = deviceState["log"].fences;

              if (fences) {
                fences.forEach(fence => {
                  let coordinates = fence.geometry.coordinates[0];
                  let polygonCoords = [];
                  coordinates.forEach(coordinate => {
                    let eachCoordinate = {
                      lat: Number(coordinate[1]),
                      lng: Number(coordinate[0])
                    };
                    polygonCoords.push(eachCoordinate);
                  });
                  allPolygons.push(polygonCoords);
                });
              }
            }
          }
        });
        this.setState({ allPolygons: allPolygons });
      }
    } else {
      this.setState({ allPolygons: [] });
    }
  };

  showRoute = () => {
    if (this.state.showRoute) {
      if (this.state.testInstance.trackedLocations) {
        let locations = Object.values(this.state.testInstance.trackedLocations);
        let routes = [];
        locations.map(location => {
          let temp = {
            lat: Number(location.latitude),
            lng: Number(location.longitude)
          };
          routes.push(temp);
        });
        this.setState({ trackedLocations: routes });
      }
    } else {
      this.setState({ trackedLocations: [] });
    }
  };

  render() {
    return (
      <MapAnalytics
        navigator={this.props.navigator}
        loadData={this.state}
        updateRuleDownload={this.updateRuleDownload}
        updateShowRoute={this.updateShowRoute}
        updateDevice={this.updateDevice}
        updateOs={this.updateOs}
      />
    ); //return
  } //render
} //MapAnalyticsWidget

export default MapAnalyticsWidget;
